<template>
  <BasePage :pageTitle="accommodationName" back-button show-menu show-footer>
    <div v-if="isLoading" class="text-center mt-3">
      <div class="spinner-border text-primary" role="status"></div>
      <span class="ms-2">{{ __DICT__.loading }}</span>
    </div>
    <template v-if="accommodation">
    <AccommodationDetailsCard :accommodation="accommodation" :keyStatus="keyStatus"
                              :room-accommodations="roomAccommodations"></AccommodationDetailsCard>
      <PaxAllocation
          :title="__DICT__.inhabitants"
          :inhabitants="inhabitants"
          :capacity="accommodation.subblock_capacity"
          :show-capacity="true"

      ></PaxAllocation>
    </template>


    <div v-else class="alert alert-danger" role="alert">
      {{ __DICT__.accommodationNotFound }}
    </div>
  </BasePage>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { useWeekStore } from '@/stores/week.js'
import BasePage from "@/components/BasePage.vue"

import PaxAllocation from "@/components/PaxAllocation.vue";
import AccommodationDetailsCard from "@/components/AccommodationDetailsCard.vue";
import {api} from "@/services/api.js";
import {passengerIndex} from "@/services/PassengerIndex.js";

const route = useRoute()
const weekStore = useWeekStore()
const isLoading = ref(true)
const keyStatus = ref(null)

const subblockId = computed(() => parseInt(route.params.subblockId))

const inhabitants = computed(() =>
    passengerIndex.getByAccommodation(subblockId.value) || []
)

// Each guest's copy of this room's accommodation (GBS sends one per guest)
const roomAccommodations = computed(() =>
    inhabitants.value
        .map(pax => pax.allocPlaces?.find(place => place.accommodation?.subblock_id === subblockId.value)?.accommodation)
        .filter(Boolean)
)

const accommodation = computed(() => roomAccommodations.value[0] || null)

const accommodationName = computed(() =>
    accommodation.value ? `${accommodation.value.name} - ${accommodation.value.subblock_physical_name}` : __DICT__.passengerView.accommodation
)

onMounted(async () => {
  try {
    keyStatus.value = await api.get(`/api/keyDist/room/${route.params.subblockId}/week/${weekStore.systemId}`)
  } catch (error) {
    console.error('Error loading key status:', error)
  } finally {
    isLoading.value = false
  }
})
</script>
